import { HeadCell } from 'components/common/TableCommon';
import { IDeploymentVersion } from 'interface/deploymentInterface';

export const headCellList: HeadCell<IDeploymentVersion>[] = [
  {
    id: 'appName',
    label: 'App Name',
    hide: false,
    cellRender: row => {
      return <>{row?.AppName}</>;
    },
  },
  {
    id: 'sliceName',
    label: 'Slice Name',
    hide: false,
    cellRender: row => {
      return <>{row?.SliceName}</>;
    },
  },
  {
    id: 'status',
    label: 'Status',
    hide: false,
    cellRender: row => {
      return <>{row?.Status}</>;
    },
  },
  {
    id: 'appVersion',
    label: 'App Version',
    hide: false,
    cellRender: row => {
      return <>{row?.AppVersion}</>;
    },
  },
  {
    id: 'workflowRunID',
    label: 'Workflow Run ID',
    hide: false,
    cellRender: row => {
      return <>{row?.WorkflowRunID}</>;
    },
  },
  {
    id: 'gitSHA',
    label: 'Git SHA',
    hide: false,
    cellRender: row => {
      return <>{row?.GitSHA}</>;
    },
  },
  {
    id: 'createdAt',
    label: 'Created At',
    hide: false,
    cellRender: row => {
      return (
        <>{row?.CreatedAt ? new Date(row.CreatedAt).toLocaleString() : ''}</>
      );
    },
  },
  {
    id: 'updatedAt',
    label: 'Updated At',
    hide: false,
    cellRender: row => {
      return (
        <>{row?.UpdatedAt ? new Date(row.UpdatedAt).toLocaleString() : ''}</>
      );
    },
  },
];
